import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    list : {
        // marginBottom:'250px
        backgroundColor:'red'
    }
}));
